import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import { Loader } from 'lucide-react';

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};
`;

const LoadingSpinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.textSecondary};
  
  svg {
    animation: spin 1s linear infinite;
    color: ${({ theme }) => theme.colors.primary};
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner>
          <Loader size={40} />
          <span>Verificando sesión...</span>
        </LoadingSpinner>
      </LoadingContainer>
    );
  }

  if (!isAuthenticated) {
    return null; // El App.tsx se encargará de mostrar el login
  }

  return <>{children}</>;
};

export default ProtectedRoute;

